<div class="page-container">
    <div class="incident-status-steps">
        <cerrix-workflow-bar [steps]="workflowSteps"></cerrix-workflow-bar>
    </div>

    <div class="incident-edit-container">
        <div class="incident-details">
            <div class="inline-text">
                <span class="grey-text">Incidents | </span
                ><span class="blue-text">{{ incidentReference }}</span>
            </div>
            <br />
            @if (incidentForm) {
                <div [formGroup]="headerDetailsForm" class="grid-container">
                    <div>
                        <cerrix-title
                            size="large"
                            placeholder="Incident name"
                            formControlName="name"
                            [showAsRequired]="true"
                            [dataUiid]="'incident-details-title'"
                        ></cerrix-title>
                        <mat-divider class="title-divider"></mat-divider>
                    </div>
                    <div></div>

                    @if (headerExpanded) {
                        <div class="header-details">
                            <div class="details-section">
                                <cerrix-field-wrapper
                                    class="details-section__staffing"
                                    label="Assigned"
                                    [required]="incident?.id !== null"
                                    ><cerrix-avatar-group
                                        [editable]="canEditStaffing"
                                        [userLists]="assignedUsers"
                                        [dataUiid]="'incident-details-assigned-users'"
                                        [rolePermissionSelection]="true"
                                        [selectedPermissionIndex]="selectedPermissionIndex"
                                        (userListsChange)="assignedUsers = $event"
                                    ></cerrix-avatar-group
                                ></cerrix-field-wrapper>
                                <cerrix-field-wrapper
                                    class="details-section__status"
                                    label="Status"
                                    [textContent]="incident?.incidentStatus?.translation"
                                ></cerrix-field-wrapper>
                                <div class="details-section__dates">
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Due date"
                                    >
                                        <cerrix-datepicker
                                            formControlName="dueDate"
                                            [minDate]="minDueDate"
                                            [dataUiid]="'incident-details-due-date'"
                                        ></cerrix-datepicker>
                                    </cerrix-field-wrapper>
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Date detected"
                                        [required]="incident?.id !== null"
                                    >
                                        <cerrix-datepicker
                                            formControlName="detectedOn"
                                            [dataUiid]="'incident-details-detected-on'"
                                            [maxDate]="futureDateLimit"
                                            (ngModelChange)="onChange('detectedOn')"
                                        ></cerrix-datepicker>
                                    </cerrix-field-wrapper>
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Date occurred"
                                    >
                                        <cerrix-datepicker
                                            formControlName="occurredOn"
                                            [dataUiid]="'incident-details-occurred-on'"
                                            [maxDate]="futureDateLimit"
                                            (ngModelChange)="onChange('occurredOn')"
                                        ></cerrix-datepicker>
                                    </cerrix-field-wrapper>
                                </div>
                            </div>
                            <div class="description-section">
                                <cerrix-field-wrapper
                                    [required]="incident?.id !== null"
                                    label="Description"
                                >
                                    <cerrix-textarea
                                        placeholder="Description"
                                        formControlName="description"
                                        [dataUiid]="'incident-details-description'"
                                        [textareaAutosize]="true"
                                        [autosizeMinRows]="7"
                                    ></cerrix-textarea>
                                </cerrix-field-wrapper>
                            </div>
                        </div>
                    } @else {
                        <div class="header-details">
                            <div class="details-section">
                                <cerrix-field-wrapper
                                    class="details-section__staffing"
                                    label="Assigned"
                                    [required]="incident?.id !== null"
                                    ><cerrix-avatar-group
                                        [editable]="canEditStaffing"
                                        [userLists]="assignedUsers"
                                        [rolePermissionSelection]="true"
                                        [selectedPermissionIndex]="selectedPermissionIndex"
                                        [dataUiid]="'incident-details-assigned-users'"
                                        (userListsChange)="onAssignedUsersChange($event)"
                                    ></cerrix-avatar-group
                                ></cerrix-field-wrapper>
                                <cerrix-field-wrapper
                                    class="details-section__status"
                                    label="Status"
                                    [textContent]="incident?.incidentStatus?.translation"
                                >
                                </cerrix-field-wrapper>
                                <div class="details-section__dates">
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Due date"
                                        [textContent]="
                                            incidentForm.get('headerDetails').get('dueDate').value
                                                | dateTimeDisplay
                                        "
                                    >
                                    </cerrix-field-wrapper>
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Date detected"
                                        [required]="true"
                                        [textContent]="
                                            incidentForm.get('headerDetails').get('detectedOn')
                                                .value | dateTimeDisplay
                                        "
                                    >
                                    </cerrix-field-wrapper>
                                    <cerrix-field-wrapper
                                        class="details-section__date"
                                        label="Date occurred"
                                        [textContent]="
                                            incidentForm.get('headerDetails').get('occurredOn')
                                                .value | dateTimeDisplay
                                        "
                                    >
                                    </cerrix-field-wrapper>
                                </div>
                            </div>
                        </div>
                    }
                    <div>
                        <button
                            mat-flat-button
                            class="section-toggle-button"
                            [attr.data-uiid]="'incident-details-header-toggle-button'"
                            (click)="toggleHeaderSection()"
                        >
                            @if (headerExpanded) {
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            } @else {
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            }
                        </button>
                    </div>
                </div>
            }

            <div class="tab-container">
                <mat-tab-group
                    #tabContentTabGroup
                    (selectedTabChange)="tabChanged($event)"
                    [attr.data-uiid]="'incident-details-tab-group'"
                    [mat-stretch-tabs]="false"
                    [dynamicHeight]="true"
                >
                    <mat-tab
                        [labelClass]="
                            formHasErrors(incidentForm?.get('details')) ? 'tab-header-error' : ''
                        "
                    >
                        <ng-template mat-tab-label>
                            <mat-icon fontSet="material-icons-outlined">check_circle</mat-icon>
                            <span data-uiid="incident-details-tab" class="mat-tab-label"
                                >Details</span
                            ></ng-template
                        >
                        @if (dataLoaded) {
                            <incident-details-tabcontent
                                [incidentTypes]="incidentTypes"
                                (onIncidentTypeChange)="onIncidentTypeChange($event)"
                                [checkDirty]="checkDirty.bind(this)"
                                [detailsForm]="detailsForm"
                                [incidentId]="incident?.id"
                                [reportedOrganizations]="reportedOrganizations"
                                [causedByOrganizations]="causedByOrganizations"
                                [affectedOrganizations]="affectedOrganizations"
                                [rootCauseCategories]="rootCauseCategories"
                                [classifications]="classifications"
                                [businessDimensions]="businessDimensions"
                                [frameworkDimensions]="frameworkDimensions"
                                [causedByThirdparties]="causedByThirdparties"
                                [affectedThirdparties]="affectedThirdparties"
                            ></incident-details-tabcontent>
                        }
                    </mat-tab>

                    @if (
                        dataLoaded && selectedIncidentTypes.length > 0 && cfRequestsInProgress === 0
                    ) {
                        @for (it of selectedIncidentTypes; track it) {
                            <mat-tab
                                #incidentTypesTab
                                [labelClass]="
                                    formHasErrors(
                                        incidentCustomFieldsForm?.controls[it.id]
                                    )
                                        ? 'tab-header-error'
                                        : ''
                                "
                            >
                                <ng-template mat-tab-label>
                                    <mat-icon fontSet="material-icons-outlined"
                                        >check_circle</mat-icon
                                    >
                                    <span
                                        [attr.data-uiid]="'incident-' + it.id + '-tab'"
                                        class="mat-tab-label"
                                        >{{ it.name }}</span
                                    ></ng-template
                                >
                                <incident-custom-fields-tab
                                    [isActive]="incidentTypesTab.isActive"
                                    [customFieldsForm]="
                                        incidentCustomFieldsForm?.controls[it.id]
                                    "
                                    [incidentType]="it"
                                    [currentSelectedOrganizations]="
                                        getCurrentlySelectedOrganizations()
                                    "
                                    [currentSelectedThirdParties]="
                                        getCurrentlySelectedThirdParties()
                                    "
                                    [currencies]="currencies"
                                    [refresh]="incidentUpdated"
                                    [dataUiid]="'incident-custom-fields-tab-' + it.id"
                                ></incident-custom-fields-tab>
                            </mat-tab>
                        }
                    }

                    @if (incident?.id) {
                        <mat-tab labelClass="right-tab-item second-right-tab">
                            <ng-template mat-tab-label>
                                <cerrix-icon
                                    [attr.data-uiid]="'incident-links-tab'"
                                    icon="linkicon"
                                    [color]="linkIconColorCode"
                                ></cerrix-icon>
                            </ng-template>

                            <incident-links-tab
                                [canEditIncident]="canEditIncident && !!incident?.id"
                                [hideCreateMoi]="hideIncidentMoiOption"
                                [incidentId]="id"
                                [riskIds]="incident.riskIds"
                                (riskIdsChange)="onRiskIdsChange($event)"
                                [controlIds]="incident.controlIds"
                                (controlIdsChange)="onControlIdsChange($event)"
                                [assetIds]="incident.assetIds"
                                (assetIdsChange)="onAssetIdsChange($event)"
                            ></incident-links-tab>
                        </mat-tab>

                        <mat-tab labelClass="right-tab-item first-right-tab">
                            <ng-template mat-tab-label>
                                <mat-icon
                                    [attr.data-uiid]="'incident-attachments-tab'"
                                    fontSet="material-icons-outlined"
                                    >attach_file</mat-icon
                                >
                            </ng-template>

                            <incident-attachments-tab
                                [canEditAttachments]="canEditAttachments"
                                [incidentId]="id"
                                [documents]="documents"
                                (documentsChange)="onDocumentsChange($event)"
                                [hyperlinks]="hyperlinks"
                                (hyperlinksChange)="onHyperlinksChange($event)"
                            ></incident-attachments-tab>
                        </mat-tab>
                        <mat-tab labelClass="right-tab-item first-right-tab">
                            <ng-template mat-tab-label>
                                <mat-icon
                                    [attr.data-uiid]="'incident-history-tab'"
                                    fontSet="material-icons-outlined"
                                    >history</mat-icon
                                >
                            </ng-template>
                            <ng-template matTabContent>
                                <incident-history [incidentId]="incident?.id"></incident-history
                            ></ng-template>
                        </mat-tab>
                    }
                </mat-tab-group>
            </div>
            <div class="action-container">
                <div class="left-container">
                    @if (showSettingsMenu) {
                        <cerrix-drop-menu
                            icon="settings"
                            iconColor="#001257"
                            dropPosition="top"
                            [dataUiid]="'incident-details-settings-menu'"
                        >
                            @if (settingsPermissions.deletePermission) {
                                <div
                                    [attr.data-uiid]="
                                        'incident-details-settings-menu-delete-button'
                                    "
                                    (click)="deleteIncident()"
                                    (keydown.delete)="deleteIncident()"
                                    tabindex="0"
                                >
                                    <cerrix-icon
                                        icon="delete"
                                        color="#0C66E4"
                                        [size]="24"
                                    ></cerrix-icon
                                    >Delete
                                </div>
                            }
                        </cerrix-drop-menu>
                    }
                    @if (
                        incident?.incidentStatus?.id !== IncidentStatus.Rejected &&
                        incident?.incidentStatus?.id !== IncidentStatus.Closed
                    ) {
                        <cerrix-button
                            [disabled]="
                                saveDisabled ||
                                (!canEditIncident && !canEditAttachments) ||
                                cfRequestsInProgress > 0
                            "
                            [dataUiid]="'incident-details-save-button'"
                            color="primary-light"
                            type="stroked"
                            [dataUiid]="'incident-details-save-button'"
                            (click)="onSave()"
                            ><ng-container>Save</ng-container
                            ><mat-icon fontSet="material-symbols-outlined"
                                >check_small</mat-icon
                            ></cerrix-button
                        >
                    }
                </div>
                <div class="right-container">
                    @if (canEditIncident) {
                        @switch (incident?.incidentStatus?.id) {
                            @case (IncidentStatus.AwaitingAcceptance) {
                                <cerrix-button
                                    [dataUiid]="'incident-details-reject-button'"
                                    [disabled]="saveDisabled || cfRequestsInProgress > 0"
                                    color="error"
                                    (click)="
                                        onIncidentStatusChange(
                                            IncidentStatus.AwaitingAcceptance,
                                            IncidentStatus.Rejected
                                        )
                                    "
                                    >Reject incident</cerrix-button
                                >
                                <cerrix-button
                                    [dataUiid]="'incident-details-accept-button'"
                                    [disabled]="saveDisabled || cfRequestsInProgress > 0"
                                    color="success"
                                    (click)="
                                        onIncidentStatusChange(
                                            IncidentStatus.AwaitingAcceptance,
                                            IncidentStatus.AwaitingImprovements
                                        )
                                    "
                                    >Accept incident</cerrix-button
                                >
                            }
                            @case (IncidentStatus.AwaitingImprovements) {
                                <cerrix-button
                                    [dataUiid]="'incident-details-AwaitingImprovements-button'"
                                    [disabled]="saveDisabled || cfRequestsInProgress > 0"
                                    color="primary"
                                    (click)="
                                        onIncidentStatusChange(
                                            IncidentStatus.AwaitingImprovements,
                                            IncidentStatus.ReadyForApproval
                                        )
                                    "
                                    >Ready for review</cerrix-button
                                >
                            }
                            @case (IncidentStatus.ReadyForApproval) {
                                <cerrix-button
                                    [dataUiid]="'incident-details-ready-for-approval-button'"
                                    [disabled]="saveDisabled || cfRequestsInProgress > 0"
                                    color="error"
                                    (click)="
                                        onIncidentStatusChange(
                                            IncidentStatus.ReadyForApproval,
                                            IncidentStatus.AwaitingImprovements
                                        )
                                    "
                                    >Reject</cerrix-button
                                >
                                <cerrix-button
                                    [dataUiid]="'incident-details-approve-close-button'"
                                    [disabled]="saveDisabled || cfRequestsInProgress > 0"
                                    color="success"
                                    (click)="
                                        onIncidentStatusChange(
                                            IncidentStatus.ReadyForApproval,
                                            IncidentStatus.Closed
                                        )
                                    "
                                    >Approve & close</cerrix-button
                                >
                            }
                        }
                    }
                    @if (canReopenIncident) {
                        <cerrix-button
                            [dataUiid]="'incident-details-reopen-button'"
                            [disabled]="saveDisabled || cfRequestsInProgress > 0"
                            color="primary-light"
                            type="stroked"
                            (click)="onReopen()"
                            ><ng-container>Reopen</ng-container></cerrix-button
                        >
                    }
                </div>
            </div>
        </div>

        <div class="right-space-container"></div>
    </div>

    @if (incident?.id) {
        <chat-toggle-button
            class="chat-toggle-button"
            [label]="chatText"
            [dataUiid]="'incident-details-chat-toggle-button'"
            (toggleChat)="onToggleComments()"
        ></chat-toggle-button>
    }
</div>

@if (incident?.id) {
    <cerrix-chat
        #chatComponent
        [canAdd]="true"
        [entityId]="incident.id"
        [comments]="comments"
        [title]="chatText + ' - ' + incident.name"
        [class]="['incident-comments', displayComments ? 'display-comments' : '']"
        (hideChat)="onToggleComments()"
    ></cerrix-chat>
}
